import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({});
  loading = false;
  hidePassword = true;
  rememberMe = false;
  baseRoute = '/admin/dashboard';
  returnUrl: string = '';
  errorMsg: string = '';
  formSubmitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService
  ) {
    if (this.route.snapshot.routeConfig?.path === 'logout') {
      this.authenticationService.logout();
      return;
    }
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate([this.baseRoute]);
    }
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || this.baseRoute;
    this.loginForm = this.formBuilder.group({
      username: ['', [
        Validators.required,
        // Validators.pattern('^(?=.*[a-zA-Z])[a-zA-Z0-9._@]+$')
      ]],
      password: ['', Validators.required],
      companyCode:['', Validators.required]
    });
  }

  login() {
    this.formSubmitted = true;
    if (this.loginForm.valid) {
      this.loading = true;
      const model = {
        email: this.loginForm.controls['username'].value,
        password: this.loginForm.controls['password'].value,
        companyCode:this.loginForm.controls['companyCode'].value
      };
      this.authenticationService.login(model).subscribe(
        (res:any) => {
          if(res.status){
            this.loading = false;
            if (this.authenticationService.canAccess(this.returnUrl.split('?')[0])) {
                //this.toastr.success('', this.translate.instant('swalMsg.success'), { progressBar: true })
                this.router.navigate([this.returnUrl], { replaceUrl: true });
              } else {
                  this.router.navigate([this.baseRoute], { replaceUrl: true });
                }
              }else{
                this.loading = false;
                this.errorMsg = res.message;
              //this.toastr.error('', res.message, { progressBar: true })
          }
          
        },
        error => {
          this.loading = false;
          if (error.status === 401) {
            this.errorMsg = this.translate.instant('forms.invalid_username_or_password_please_try_again');
          } else if (error.status === 404) {
            this.errorMsg = this.translate.instant('forms.user_not_found_please_check_your_credentials');
          } else {
           this.errorMsg = this.translate.instant('forms.an_error_occurred_during_login_please_try_again_later');
          }
        });
    }
  }

  hasError(controlName: string, errorName: string) {
    return this.loginForm.controls[controlName].hasError(errorName);
  }
}
